import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/faq.css";

const faqs = [
  {
    question:
      "Mennyi ideig tart egy olajcsere Szolnokon az autószervizetekben?",
    answer:
      "Átlagosan 30–45 perc alatt elkészül az olajcsere, ha előre foglalsz időpontot. Szerelőkészletünk és tapasztalatunk lehetővé teszi a gyors munkavégzést.",
  },
  {
    question: "Milyen olajat használtok az olajcseréhez?",
    answer:
      "Mindig az adott autótípushoz ajánlott, gyári minőségű motorolajat használunk, prémium márkákból (pl. Castrol, Mobil, Total).",
  },
  {
    question: "Használt autó vásárlása után kötelező az olajcsere?",
    answer:
      "Igen, nagyon ajánlott azonnal olajat és szűrőt cserélni, hiszen nem tudhatod, mikor történt utoljára karbantartás. Ez megelőzheti a súlyos motorhibákat.",
  },
  {
    question: "Vállaltok fékellenőrzést is?",
    answer:
      "Igen, teljes fékállapot-felmérést és fékcsere szolgáltatást végzünk Szolnokon – fékbetét, tárcsa, fékfolyadék ellenőrzés és csere is elérhető.",
  },
  {
    question: "Mennyibe kerül egy olajcsere?",
    answer:
      "A pontos ár az autó típusától és az olaj mennyiségétől függ, de mindig előre egyeztetjük. Nincsenek rejtett költségek.",
  },
  {
    question: "Lehet helyben megvárni a szervizelést?",
    answer:
      "Igen, van váróhelyiségünk, így kényelmesen megvárhatod az olajcserét vagy fékcserét Szolnokon – és amíg elkészül az autód, vendégünk vagy egy finom kávéra.",
  },
  {
    question: "Kell előre időpontot foglalni?",
    answer:
      "Igen, ajánlott előre egyeztetni telefonon, így garantálni tudjuk a gyors kiszolgálást és az aznapi elvégzést.",
  },
  {
    question: "Milyen gyakran kell olajat cserélni?",
    answer:
      "Általában 10–15 000 km-enként, de mindig az autó gyártói előírásai az irányadók.",
  },
  {
    question: "Végeztek teljes állapotfelmérést autóvásárlás előtt?",
    answer:
      "Igen, használt autó vásárlása előtt érdemes kérni egy komplett műszaki állapotfelmérést, hogy elkerüld a későbbi meglepetéseket.",
  },
  {
    question: "Hol található a szerviz pontosan Szolnokon?",
    answer:
      "Autószervizünk címe: 5000 Szolnok, Véső utca 1. Könnyen megközelíthető, ingyenes parkolással.",
  },
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section" id="faq">
      <div className="container faq-div">
        <h2 className="h2-header pb-3" dtata-aos="fade-up">
          Gyakran Ismételt Kérdések – minden, amit tudni érdemes szolnoki
          autószervizünkről
        </h2>
        <div className="divider">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <p className="services-intro text-center mb-5">
          Összegyűjtöttük a leggyakoribb kérdéseket, hogy gyorsabban eligazodjon
          szolgáltatásaink, az időpontfoglalás és a szolnoki olajcsere és
          fékcsere menete kapcsán. Ha valamire nem talál választ, keressen
          minket bizalommal – szívesen segítünk!
        </p>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "open" : ""}`}
              onClick={() => toggle(index)}
              data-aos="fade-up"
              data-aos-delay={100}
            >
              <div className="faq-question">
                <span className="faq-text">{faq.question}</span>
                <span className="faq-icon">
                  {openIndex === index ? "−" : "+"}
                </span>
              </div>
              {openIndex === index && (
                <div className="faq-answer" data-aos="fade-in">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="svg-divider">
        <svg
          viewBox="0 0 1440 320"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path fill="#fff" d="M0,160L720,0L1440,160V0H0Z" />
        </svg>
      </div>
    </section>
  );
};

export default FaqSection;
